import { getAvailableAppearances } from '@/model/productType/getAvailableAppearances';
import { StoreState } from '@/redux/types';
import { getProductType } from './getProductType';

export const getAppearancesForCurrentProductType = (state: StoreState) =>
  getAvailableAppearances(getProductType(state));
